<template>
    <div>
        <v-card class="elevation-0">
            <v-row>
            <v-col justify="center" align="center">
                <v-card-text class="mt-3 mb-1 text-h5 font-weight-black">DIKLAT & SOSIALISASI</v-card-text>
            </v-col>
          </v-row>
            <v-layout wrap justify-center class="d-flex mt-2">

            <v-layout wrap justify-center>
                <v-card
                    max-width="400"
                    xs12 sm4 px-3
                    class="mx-2 my-2 rounded-lg"
                    v-for="(item, i) in itemsFTemplateReg"
                    :key="i"
                    elevation="10"
                >

                  <v-img
                      height="280"
                      :lazy-src="lookupImageUrlLazy(item)"
                      :src="lookupImageUrl(item)"
                  >
                    <v-card-title class="blue--text">DINAS PUPR - BIKON</v-card-title>
                  </v-img>

                  <v-card-title>
                    <div class="subtitle-1">
                      {{item.description}}
                    </div>
                  </v-card-title>
                  <v-card-subtitle>
                    <div class="mt-1">
                      <span class="green--text">
                        {{ computedDateFormattedDatefns(item.trDateFrom) }}
                      </span>
                      SD
                      <span class="green--text">
                        {{ computedDateFormattedDatefns(item.trDateTo) }}
                      </span>
                    </div>

                    <v-flex v-if="item.kuota >0" class="mt-1">
                      <v-icon>mdi-human-male</v-icon> Kuota <span class="font-weight-bold">{{item.kuota}}</span>
                    </v-flex>
                    <v-flex class="caption font-weight-thin d-flex justify-end" v-if="false">
                      {{item.id}}
                    </v-flex>
                  </v-card-subtitle>

                  <v-card-text>

                    <v-divider></v-divider>
                    <div class="mt-1" v-html="item.notes"></div>

                    <div>Pendaftaran Buka</div>
                    <span class="blue--text">
                      {{ computedDateFormattedDatefns(item.openFrom) }}
                    </span>
                    <span class="grey--text caption">SD</span>
                    <span class="blue--text">
                      {{ computedDateFormattedDatefns(item.openTo) }}
                    </span>

<!--                    <v-flex class="d-flex justify-end" v-if="isSudahTutupPendaftaran(item.fperiodeBeanRes)">-->
<!--                      <v-btn rounded color="red lighten-4"  class="mt-4 mx-0" >-->
<!--                        Maaf Sudah Tutup-->
<!--                        <v-icon small>mdi-close</v-icon>-->
<!--                      </v-btn>-->
<!--                    </v-flex>-->
<!--                    <v-flex class="d-flex justify-end" v-else-if="!isSudahBukaPendaftaran(item.fperiodeBeanRes)">-->
<!--                      <v-btn rounded color="grey" dark class="mt-4 mx-0" >-->
<!--                        Belum Buka-->
<!--                        <v-icon small>mdi-flag-checkered</v-icon>-->
<!--                      </v-btn>-->
<!--                    </v-flex>-->
<!--               -->
                    <v-flex class="d-flex justify-end">
<!--                      <v-btn rounded color="primary" dark class="mt-4 mx-0" :to="`ppdb-market-item/` + linkNeated(item.id.toString())">-->
<!--                        Daftar Sekarang-->
<!--                        <v-icon small>mdi-walk</v-icon>-->
<!--                      </v-btn>-->

                      <v-btn rounded color="primary" dark class="mt-4 mx-0" :to="`/login/`" v-if="currentUser !== null">
                        Daftar Sekarang (Login Dahulu)
                        <v-icon small>mdi-walk</v-icon>
                      </v-btn>
                      <v-btn rounded color="primary" dark class="mt-4 mx-0" :to="`/registrasi-layanan/${item.id}` " v-else>
                        Daftar Sekarang
                        <v-icon small>mdi-walk</v-icon>
                      </v-btn>

                    </v-flex>

                  </v-card-text>

                </v-card>

          </v-layout>

              <div v-if="false">
                <div v-for="(item,i) in itemsFTemplateReg" :key="i" >
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <v-card
                          :to="`/registrasi-layanan/${item.id}`"
                          width="400"
                          height="600"
                          xs12 sm4 px-3
                          class="ma-3 rounded-lg pb-6"
                          :elevation="hover? 16: 3">
                        <div>
                          <v-hover>
                            <template v-slot:default="{ hover }">
                              <v-img
                                  style="background-color: white;"
                                  height="165"
                                  :lazy-src="lookupImageUrlLazy(item)"
                                  :src="lookupImageUrl(item)"
                                  :class="{ 'hover-image': hover }"
                                  class="rounded-lg mx-6 mt-2 mb-1"
                              ></v-img>
                            </template>
                          </v-hover>
                        </div>
                        <v-divider class="mx-4 mt-2"></v-divider>
                        <v-card-title class=" text-center justify-center subtitle-2 font-weight-bold">{{ item.description }}</v-card-title>
                      </v-card>
                    </template>
                  </v-hover>
                </div>

              </div>

          </v-layout>
          <v-row v-if="false">
            <v-col justify="center" align="center">
                <v-card-text class="mt-16 text-h5 font-weight-black">TOOLS</v-card-text>
            </v-col>
          </v-row>
          <v-layout wrap justify-center class="d-flex mt-2" v-if="false">
            <div v-for="(item,i) in itemsTool" :key="i">
              <v-hover>
                <template v-slot:default="{ hover }">
                    <v-card
                      @click="routeToExternalLink(item)"
                      width="190"
                      height="210"
                      xs12 sm4 px-3
                      class="ma-3 rounded-lg pb-6"
                      :elevation="hover? 16: 3">
                      <div>
                        <v-hover>
                          <template v-slot:default="{ hover }">
                            <v-img
                              style="background-color: white;"
                              height="145"
                              contain
                              :src="item.image"
                              :class="{ 'hover-image': hover }"
                              class="rounded-lg"
                            ></v-img>
                          </template>
                        </v-hover>
                      </div>
                      <v-divider class="mx-4 mt-2"></v-divider>
                      <v-card-title class="text-center justify-center subtitle-2 font-weight-black">{{ item.description }}</v-card-title>
                    </v-card>
                </template>
              </v-hover>
            </div>
          </v-layout>
        </v-card>
    </div>
</template>
<script>
  import FTemplateRegService from '@/services/apiservices/f-template-reg-service';
  import FTemplateReg from '@/models/f-template-reg'
  import FileService from "@/services/apiservices/file-service";
  import {format, parseISO} from "date-fns";

  export default {
    name: "FtTemplateRegMainCardMain",
    components: {
    },
    data () {
      return {
        itemsTool: [
            {id: 1, image: "./assets/images/PDF.png", description: "PDF Convert Tools", url: "https://www.ilovepdf.com/id", to_newtab: true},
            {id: 2, image: "./assets/images/TEMPLATE.png", description: "Download Template", url: "", to_newtab: false},
        ],
        stepperPage: 1,
        title: 'TEMPLATE REGISTRASI',
        snackbar: false,
        snackBarMesage: '',
  
        multiSelect: false,
        selectedItems: [],
  
        currentPage: 1,
        totalTablePages: 1,
        totalPaginationPages: 1,
        pageSize: 10,
        pageSizes: [10, 25, 50, 150, 500, 1500],
        search: '',
        headers: [
        {
            text: 'No',
            value: 'number',
            width: '8%',
            sortable: false
          },
          {
            text: '',
            align: 'center',
            sortable: false,
            value: 'avatarImage',
            width: '16%'
          },
          { text: 'Deskripsi', value: 'description', width:"40%" },
          { text: 'Division', value: 'fdivisionBean', width:"10%" },
          { text: 'Actions', value: 'actions', sortable: false, width:"20%", align: "center" },
        ],
        // formMode: '',
        itemSelectedIndex: -1,
        itemSelected: '',
        fTemplateRegs:[
          new FTemplateReg(0, '','')
        ],
      }
    },
    watch: {
      currentPage: {
        handler: function (value) {
          if (value) this.fetchFTemplateReg()
        }
      },
      pageSize: {
        handler: function () {
          const refreshData = (this.currentPage===1)
          this.currentPage =1
          if (refreshData) {
            // console.log("Change PageSize " + value)
            this.fetchFTemplateReg()
          }
          // console.log("page size = " + value + " >> " + this.totalPages)
        }
      },
    },
    computed: {
      currentUser(){
        return this.$store.state.auth.user;
      },
      fTemplateRegsFiltered(){
        return this.fTemplateRegs
      },
      formMode: {
          get() {
            return this.$store.state.FTemplateRegModule.formMode
          },
          set (value){
            this.$store.dispatch('FTemplateRegModule/updateFormMode', value)
          }
      },

      itemsFTemplateReg: {
        get(){
          return this.$store.state.FtRegistrasiModule.itemsFTemplateReg
        },
        set (value){
          this.$store.dispatch('FtRegistrasiModule/updateItemsFTemplateReg', value)
        }
      },

    },
    methods: {
      isSudahBukaPendaftaran(value){
        let sudahBuka = false
        const now = new Date();
        if (now >= new Date(value.daftarOpenFrom) && now <= new Date(value.daftarCloseTo)){
          sudahBuka = true
        }

        return sudahBuka
      },
      isSudahTutupPendaftaran(value){
        let sudahTutup = false
        const now = new Date();
        if (now >= new Date(value.daftarCloseTo)){
          sudahTutup = true
        }

        return sudahTutup

      },

      nextStep(step, item){
        this.$emit('nextStep', { step, item })
      },
      routeToExternalLink(item){
        console.log(item)
        this.$router.push('/login')

      },
      searchOnEnter(event){
        if (this.search !== event.target.value) { //Krusial untuk search
          // console.log(`${event.target.value} vs ${this.search}`)
          this.currentPage = 1
          this.search = event.target.value
          this.fetchFTemplateReg()
        }
      },
      fetchParent(){
          FTemplateRegService.getAllFTemplateRegPublic().then(
              response => {
                // console.log(JSON.stringify(response.data))

                this.itemsFTemplateReg = response.data
              },
              error => {
                console.log(error.response)
              }
          )

      },

      linkNeated(link){
        return link.replace(/\s+/g, '-').toLocaleLowerCase()
      },

      getColorStatusActive (trueFalse) {
        if (trueFalse === true) return 'green'
        else if (trueFalse === false) return 'gray'
        else return 'gray'
      },
      lookupFDivision (fdivisionBean) {
        const str = this.itemsFDivision.filter(x => x.id===fdivisionBean)
        if (str.length>0){
          return str[0]
        }else {
          return '-'
        }
      },
      lookupImageUrl(item){
        if (item.avatarImage===undefined || item.avatarImage===""){
          return './assets/images/no_image_available.jpeg'
        }else {
          return FileService.image_url_low(item.avatarImage)
        }
      },
      lookupImageUrlLazy(item){
        if (item.avatarImage===undefined || item.avatarImage===""){
          return './assets/images/no_image_available.jpeg'
        }else {
          return FileService.image_url_verylow(item.avatarImage)
        }
      },
      computedDateFormattedDatefns (value) {
        return value ? format(parseISO(value), 'dd-MMM-yyyy') : ''
      },
      dateTimeFormat (value) {
        return value ? format(parseISO(value), 'dd-MMM-yyyy hh:mm:ss') : ''
      },
      formattedCurrencyValue(prefix, value){
        if(! value){ return "0"}
        // return "Rp." + parseFloat(value).toFixed(0).toLocaleString()
        return prefix + "" + parseFloat(value).toLocaleString()
      },

    },
    mounted() {
      // if (!this.currentUser) {
      //   this.$router.push('/login')
      // }else {
      //   this.fetchParent()
      //   this.fetchFTemplateReg()
      // }

      this.fetchParent()


    }
  
  }
  </script>
  